// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'
var WarningForChangeFromLastPriceGroup = function (pfixFieldSet)    
{
    PFixFieldSet.call(this, FieldsFactory.WARNING_FOR_CHANGE_FROM_LAST_PRICE_GROUP, null, pfixFieldSet)
}
WarningForChangeFromLastPriceGroup.prototype = Object.create(PFixFieldSet.prototype)


WarningForChangeFromLastPriceGroup.prototype.getPriceLowLimit = function ()
{
    return this.GetValue(FieldsFactory.FIELD_PRICE_LOW_LIMIT) || 0
}
// WarningForChangeFromLastPriceGroup.prototype.setPriceLowLimit = function (priceLowLimit)
// {
//     this.SetField(FieldsFactory.FIELD_PRICE_LOW_LIMIT, priceLowLimit)
// }

WarningForChangeFromLastPriceGroup.prototype.getLastChange = function ()
{
    return this.GetValue(FieldsFactory.FIELD_LAST_CHANGE)
}
// WarningForChangeFromLastPriceGroup.prototype.setLastChange = function (lastChange)
// {
//     this.SetField(FieldsFactory.FIELD_LAST_CHANGE, lastChange)
// }
export { WarningForChangeFromLastPriceGroup }